import { axiosApi } from "@/lib/api/axiosApi"

export const logoutService = async (domain: string) => {
  const response = await axiosApi.get(
    `/sso/${domain}/logout`
  )
  return response.data
}
